import DashboardContainer from "@containers/Dashboard/DashboardContainer";
import withPrivate from "@utils/withPrivate";

export default withPrivate(DashboardContainer)
